import apiClient from './apiClient';

/** Mirrors `backend/modules/migration/mapping.service.ts` and `dryRun.service.ts` (PRD 12 §3). */

export interface V1PlanMappingRow {
  planId: string;
  name: string;
  keywords: string[];
  weekCount: number;
  activeAthletes: number;
  v2PlanId: string | null;
  v2PlanName: string | null;
  v2Generable: boolean | null;
  mapped: boolean;
}

export interface MappingPayload {
  plans: V1PlanMappingRow[];
  counters: { mappedPlans: number; totalPlans: number; coveredAthletes: number; totalAthletes: number };
}

export interface DryRunReport {
  athletes: number;
  ready: number;
  blocked: number;
  unmapped: Array<{ planId: string; name: string; athletes: number }>;
  notGenerable: Array<{ planId: string; name: string; athletes: number }>;
  failures: Array<{ userId: string; v1PlanName: string; outcome: string; reason: string }>;
  preparations: Record<string, number>;
  outcomes: Record<string, number>;
}

export interface CutoverResult {
  migrated: number;
  skipped: number;
  failed: number;
  outcomes: Array<{ userId: string; enrollmentId: string; status: string; outcome: string; reason?: string }>;
}

export interface CutoverStatus {
  running: boolean;
  startedAt: string | null;
  finishedAt: string | null;
  result: CutoverResult | null;
  error: string | null;
}

export const getMigrationMapping = async (): Promise<MappingPayload> =>
  (await apiClient.get('admin/migration/mapping')).data as MappingPayload;

export const saveMigrationMapping = async (
  mappings: Array<{ planId: string; v2PlanId: string | null }>
): Promise<MappingPayload> => (await apiClient.put('admin/migration/mapping', { mappings })).data as MappingPayload;

export const runMigrationDryRun = async (): Promise<DryRunReport> =>
  (await apiClient.post('admin/migration/dry-run')).data as DryRunReport;

/** With an email the run is inline and returns its result; without, it starts in the background. */
export const applyMigration = async (email?: string): Promise<CutoverResult | CutoverStatus> =>
  (await apiClient.post('admin/migration/apply', email ? { email } : {})).data as CutoverResult | CutoverStatus;

export const getMigrationApplyStatus = async (): Promise<CutoverStatus> =>
  (await apiClient.get('admin/migration/apply/status')).data as CutoverStatus;
